import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import { PlanResource } from 'dy-frontend-http-repository/lib/modules/SubscriptionPlan/resources';
import domain from './domain';
import { resetSubscriptionPlans } from './events';

// Subscription plans
export const $subscriptionPlans = domain
    .createStore<CollectionResource<PlanResource, {}> | null>(null)
    .reset(resetSubscriptionPlans);
